import { FC, useMemo } from "react";
import { Button, Text, VStack } from "@chakra-ui/react";

import { IOperation } from "../../../../../api/operations/types.ts";
import { OperationItemDetailsText } from "./OperationItemDetailsText.tsx";
import { formatDate, formatPriceWithoutZeros, isStringWithNumber, isValidDate } from "../../../../../utils";

interface Props {
  operation: IOperation;
  onClose: () => void;
}

export const OperationItemDetailsModal: FC<Props> = ({ operation, onClose }) => {
  const rawAmount = operation.amount;
  const formattedAmount = isStringWithNumber(rawAmount) ? formatPriceWithoutZeros(Number(operation.amount)) : "";
  const amount = formattedAmount ? `- ${formattedAmount}` : "";

  const dateFormat = { hour: "2-digit", minute: "2-digit", hourCycle: "h23" } as Intl.DateTimeFormatOptions;
  const formattedDate = isValidDate(operation.date) ? formatDate(new Date(operation.date!), dateFormat) : "";
  const date = formattedDate.replace(" в ", ", ");

  const { statusText, statusVariant } = useMemo(() => {
    let text = "";
    let variant: "green" | "brand" | "gray" = "gray";

    switch (operation.status) {
      case "COMPLETED": {
        text = "Успешно";
        variant = "green";
        break;
      }
      case "CANCELLED": {
        text = "Отменена";
        variant = "brand";
        break;
      }
      case "PENDING": {
        text = "В обработке";
        variant = "gray";
        break;
      }
    }

    return { statusText: text, statusVariant: variant };
  }, [operation.status]);

  return (
    <VStack pt="12px" px="4px">
      <Text variant="brand" fontFamily="Normalidad Medium Var" fontSize="20px" mb="2px">{amount}</Text>
      <Text fontSize="sm" pb="15px">{`Покупка ${date}`}</Text>
      <Text w="100%" variant="brand" fontFamily="Normalidad Medium Var" mb="5px">Информация</Text>

      <OperationItemDetailsText title="Тип" text="Покупка" />
      <OperationItemDetailsText title="Операция" text={operation.salePoint?.name} />
      <OperationItemDetailsText title="Статус" text={statusText} variant={statusVariant} />

      <Button w="100%" pt="1px" mt="12px" onClick={onClose}>
        Закрыть
      </Button>
    </VStack>
  );
};
